module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<li\nclass=\"<%- (model.optionSelected ? 'disabled ' : ''); %>\"\n<%- (model.valueItem ? 'data-index=\"' + model.relationDataIndex + '\"' : '') %>\ndata-value=\"<%= model.value %>\"\n>\n<%= model.name %>\n<%\nif(model.valueItem){\n%>\n<button class=\"delete\">\n<i class=\"fi fi-trash\"></i>\n</button>\n<%\n}\n%>\n</li>"
  , __filename = "..\\frontend-controller\\baseComponents\\form\\fields\\tagPickerOption.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<li\nclass=\"")
    ; __line = 2
    ; __append( (model.optionSelected ? 'disabled ' : '') )
    ; __append("\"\n")
    ; __line = 3
    ; __append( (model.valueItem ? 'data-index="' + model.relationDataIndex + '"' : '') )
    ; __append("\ndata-value=\"")
    ; __line = 4
    ; __append(escapeFn( model.value ))
    ; __append("\"\n>\n")
    ; __line = 6
    ; __append(escapeFn( model.name ))
    ; __append("\n")
    ; __line = 7
    ; 
if(model.valueItem){

    ; __line = 9
    ; __append("\n<button class=\"delete\">\n<i class=\"fi fi-trash\"></i>\n</button>\n")
    ; __line = 13
    ; 
}

    ; __line = 15
    ; __append("\n</li>")
    ; __line = 16
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\form\fields\tagPickerOption.ejs

}